// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderControls_container__27SLd","button":"OrderControls_button___UPox","icon":"OrderControls_icon__3b7u_"};